import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _dec, _class;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { QueueFlyoutTab, PageHeader, SecondaryButton, ButtonBar, Spinner, DataTable } from 'components';
import { AppLayout, LeftNavLayout } from 'containers';
import { updateUserSettings } from 'redux/modules/userSettings';
import { getCountryVerificationFields, createStripeBankToken, createCommissionAccount, listAccountTransfers, getCommissionsAccountBalance, loadCommissionsAccount } from 'redux/modules/billing';
import { updateUser } from 'redux/modules/auth';
import { LLTextField, LLDropDownList } from 'components/FormElements';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import CommissionsView from './CommissionsView';
import * as styles from './BillingCommissions.scss';

var numberArrayGenerator = require('number-array-generator');

var moment = require('moment');

var stateDropdownData = {
  US: [{
    name: 'ALABAMA',
    abbreviation: 'AL'
  }, {
    name: 'ALASKA',
    abbreviation: 'AK'
  }, {
    name: 'ARIZONA',
    abbreviation: 'AZ'
  }, {
    name: 'ARKANSAS',
    abbreviation: 'AR'
  }, {
    name: 'CALIFORNIA',
    abbreviation: 'CA'
  }, {
    name: 'COLORADO',
    abbreviation: 'CO'
  }, {
    name: 'CONNECTICUT',
    abbreviation: 'CT'
  }, {
    name: 'DELAWARE',
    abbreviation: 'DE'
  }, {
    name: 'DISTRICT OF COLUMBIA',
    abbreviation: 'DC'
  }, {
    name: 'FLORIDA',
    abbreviation: 'FL'
  }, {
    name: 'GEORGIA',
    abbreviation: 'GA'
  }, {
    name: 'HAWAII',
    abbreviation: 'HI'
  }, {
    name: 'IDAHO',
    abbreviation: 'ID'
  }, {
    name: 'ILLINOIS',
    abbreviation: 'IL'
  }, {
    name: 'INDIANA',
    abbreviation: 'IN'
  }, {
    name: 'IOWA',
    abbreviation: 'IA'
  }, {
    name: 'KANSAS',
    abbreviation: 'KS'
  }, {
    name: 'KENTUCKY',
    abbreviation: 'KY'
  }, {
    name: 'LOUISIANA',
    abbreviation: 'LA'
  }, {
    name: 'MAINE',
    abbreviation: 'ME'
  }, {
    name: 'MARYLAND',
    abbreviation: 'MD'
  }, {
    name: 'MASSACHUSETTS',
    abbreviation: 'MA'
  }, {
    name: 'MICHIGAN',
    abbreviation: 'MI'
  }, {
    name: 'MINNESOTA',
    abbreviation: 'MN'
  }, {
    name: 'MISSISSIPPI',
    abbreviation: 'MS'
  }, {
    name: 'MISSOURI',
    abbreviation: 'MO'
  }, {
    name: 'MONTANA',
    abbreviation: 'MT'
  }, {
    name: 'NEBRASKA',
    abbreviation: 'NE'
  }, {
    name: 'NEVADA',
    abbreviation: 'NV'
  }, {
    name: 'NEW HAMPSHIRE',
    abbreviation: 'NH'
  }, {
    name: 'NEW JERSEY',
    abbreviation: 'NJ'
  }, {
    name: 'NEW MEXICO',
    abbreviation: 'NM'
  }, {
    name: 'NEW YORK',
    abbreviation: 'NY'
  }, {
    name: 'NORTH CAROLINA',
    abbreviation: 'NC'
  }, {
    name: 'NORTH DAKOTA',
    abbreviation: 'ND'
  }, {
    name: 'OHIO',
    abbreviation: 'OH'
  }, {
    name: 'OKLAHOMA',
    abbreviation: 'OK'
  }, {
    name: 'OREGON',
    abbreviation: 'OR'
  }, {
    name: 'PENNSYLVANIA',
    abbreviation: 'PA'
  }, {
    name: 'PUERTO RICO',
    abbreviation: 'PR'
  }, {
    name: 'RHODE ISLAND',
    abbreviation: 'RI'
  }, {
    name: 'SOUTH CAROLINA',
    abbreviation: 'SC'
  }, {
    name: 'SOUTH DAKOTA',
    abbreviation: 'SD'
  }, {
    name: 'TENNESSEE',
    abbreviation: 'TN'
  }, {
    name: 'TEXAS',
    abbreviation: 'TX'
  }, {
    name: 'UTAH',
    abbreviation: 'UT'
  }, {
    name: 'VERMONT',
    abbreviation: 'VT'
  }, {
    name: 'VIRGINIA',
    abbreviation: 'VA'
  }, {
    name: 'WASHINGTON',
    abbreviation: 'WA'
  }, {
    name: 'WEST VIRGINIA',
    abbreviation: 'WV'
  }, {
    name: 'WISCONSIN',
    abbreviation: 'WI'
  }, {
    name: 'WYOMING',
    abbreviation: 'WY'
  }],
  CA: [{
    name: 'ALBERTA',
    abbreviation: 'AB'
  }, {
    name: 'BRITISH COLUMBIA',
    abbreviation: 'BC'
  }, {
    name: 'MANITOBA',
    abbreviation: 'MB'
  }, {
    name: 'NEW BRUNSWICK',
    abbreviation: 'NB'
  }, {
    name: 'NEWFOUNDLAND AND LABRADOR',
    abbreviation: 'NL'
  }, {
    name: 'NOVA SCOTIA',
    abbreviation: 'NS'
  }, {
    name: 'NORTHWEST TERRITORIES',
    abbreviation: 'NT'
  }, {
    name: 'NUNAVUT',
    abbreviation: 'NU'
  }, {
    name: 'ONTARIO',
    abbreviation: 'ON'
  }, {
    name: 'PRINCE EDWARD ISLAND',
    abbreviation: 'PE'
  }, {
    name: 'QUEBEC',
    abbreviation: 'QC'
  }, {
    name: 'SASKATCHEWAN',
    abbreviation: 'SK'
  }, {
    name: 'YUKON TERRITORY',
    abbreviation: 'YT'
  }]
};
var BillingCommissions = (_dec = connect(function (state) {
  return {
    user: state.auth.user,
    verificationFields: state.billing.stripeConnectVerificationFields,
    fetchingFields: state.billing.fetchingStripeConnectVerificationFields,
    countrySpec: state.billing.stripeCountry,
    config: state.config,
    commissionsAccount: state.billing.commissionsAccount,
    loadingCommissionAccount: state.billing.loadingCommissionAccount
  };
}, {
  loadCommissionsAccount: loadCommissionsAccount,
  getCountryVerificationFields: getCountryVerificationFields,
  createStripeBankToken: createStripeBankToken,
  createCommissionAccount: createCommissionAccount,
  listAccountTransfers: listAccountTransfers,
  getCommissionsAccountBalance: getCommissionsAccountBalance
}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(BillingCommissions, _Component);

  var _super = _createSuper(BillingCommissions);

  function BillingCommissions(props) {
    var _this2;

    _classCallCheck(this, BillingCommissions);

    _this2 = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this2), "handleCountryChange", function (val) {
      _this2.fetchRequiredVerificationFields(val.id);

      _this2.setState({
        form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
          selectedCountry: val,
          state: undefined
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "fetchRequiredVerificationFields", function (countryCode) {
      _this2.props.getCountryVerificationFields(countryCode);
    });

    _defineProperty(_assertThisInitialized(_this2), "renderIdentityForm", function () {
      var type = _this2.state.form.identityType;

      if (!_this2.props.verificationFields || !_this2.props.verificationFields.individual) {
        return null;
      }

      var fields = _this2.props.verificationFields[type === 'IND' ? 'individual' : 'company'].minimum;
      var addressSection = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.address1,
        name: "address1",
        placeholder: "Address 1",
        stripe: "address_line1",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              address1: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.address2,
        name: "address2",
        placeholder: "Address 2",
        stripe: "address_line2",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              address2: val
            })
          });
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-4"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.city,
        name: "locality",
        placeholder: "City",
        stripe: "address_city",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              city: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-5"
      }, /*#__PURE__*/React.createElement(LLDropDownList, {
        style: {
          marginTop: 17
        },
        items: [{
          id: undefined,
          title: _this2.localizedFieldName('address_state')
        }].concat(_toConsumableArray(stateDropdownData[_this2.state.form.selectedCountry.id].map(function (i) {
          return {
            id: i.abbreviation,
            title: i.name
          };
        }))),
        value: _this2.state.form.state,
        fullWidth: true,
        onChange: function onChange(val) {
          _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              state: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-3"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.postcode,
        name: "postcode",
        stripe: "address_zip",
        fullWidth: true,
        placeholder: "Postal Code",
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              postcode: val
            })
          });
        }
      }))))));
      var ssnSection = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        name: "ssn",
        type: "password",
        placeholder: "Last 4 of your Social Security Number",
        stripe: "ssn",
        fullWidth: true,
        value: _this2.state.form.last4ssn,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              last4ssn: val
            })
          });
        }
      }))))));
      var nameSection = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.firstName,
        name: "first_name",
        placeholder: "First Name",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              firstName: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.lastName,
        name: "last_name",
        placeholder: "Last Name",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              lastName: val
            })
          });
        }
      }))))));
      var bizSection = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.businessName,
        name: "business_name",
        placeholder: "Business Name",
        stripe: "business_name",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              businessName: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-6"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        value: _this2.state.form.businessTaxId,
        name: "business_tax_id",
        type: "password",
        placeholder: "Business Tax ID",
        stripe: "business_tax_id",
        fullWidth: true,
        onChange: function onChange(e, val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              businessTaxId: val
            })
          });
        }
      }))))));
      var dobSection = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          lineHeight: '57px',
          verticalAlign: 'top'
        }
      }, "Date of Birth:"), /*#__PURE__*/React.createElement(LLDropDownList, {
        items: numberArrayGenerator(1, 12).map(function (num) {
          return {
            id: num,
            title: "".concat(moment("".concat(num), 'MM').format('MMMM'))
          };
        }),
        value: {
          id: _this2.state.form.verificationFields['legal_entity.dob.month'],
          title: moment("".concat(_this2.state.form.verificationFields['legal_entity.dob.month']), 'MM').format('MMMM')
        },
        onChange: function onChange(val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              verificationFields: _objectSpread(_objectSpread({}, _this2.state.form.verificationFields), {}, {
                'legal_entity.dob.month': val.id
              })
            })
          });
        }
      }), /*#__PURE__*/React.createElement(LLDropDownList, {
        items: numberArrayGenerator(1, 31).map(function (num) {
          return {
            id: num,
            title: "".concat(num)
          };
        }),
        value: {
          id: parseInt(_this2.state.form.verificationFields['legal_entity.dob.day']),
          title: "".concat(_this2.state.form.verificationFields['legal_entity.dob.day'])
        },
        onChange: function onChange(val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              verificationFields: _objectSpread(_objectSpread({}, _this2.state.form.verificationFields), {}, {
                'legal_entity.dob.day': val.id
              })
            })
          });
        }
      }), /*#__PURE__*/React.createElement(LLDropDownList, {
        items: numberArrayGenerator(moment().year() - 118, moment().year() - 18).map(function (num) {
          return {
            id: num,
            title: "".concat(num)
          };
        }),
        value: {
          id: parseInt(_this2.state.form.verificationFields['legal_entity.dob.year']),
          title: "".concat(_this2.state.form.verificationFields['legal_entity.dob.year'])
        },
        onChange: function onChange(val) {
          return _this2.setState({
            form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
              verificationFields: _objectSpread(_objectSpread({}, _this2.state.form.verificationFields), {}, {
                'legal_entity.dob.year': val.id
              })
            })
          });
        }
      })))));
      return /*#__PURE__*/React.createElement("span", null, fields.indexOf('legal_entity.first_name') !== -1 ? nameSection : null, fields.indexOf('legal_entity.dob.month') !== -1 ? dobSection : null, fields.indexOf('legal_entity.ssn_last_4') !== -1 ? ssnSection : null, fields.indexOf('legal_entity.business_name') !== -1 || fields.indexOf('legal_entity.business_tax_id') !== -1 ? bizSection : null, fields.indexOf('legal_entity.address.city') !== -1 || fields.indexOf('legal_entity.address.state') !== -1 ? addressSection : null, fields.indexOf('tos_acceptance.date') !== -1 ? /*#__PURE__*/React.createElement("p", {
        style: {
          lineHeight: '20px'
        }
      }, /*#__PURE__*/React.createElement("a", {
        className: styles.link,
        href: "https://stripe.com/about",
        target: "_blank",
        rel: "noopener"
      }, "Stripe.com"), ' ', "manages our payment processing. By setting up Commissions, you agree to the", ' ', /*#__PURE__*/React.createElement("a", {
        className: styles.link,
        href: "https://stripe.com/us/connect-account/legal",
        target: "_blank",
        rel: "noopener"
      }, "Stripe Connected Account Agreement"), ".") : null);
    });

    _defineProperty(_assertThisInitialized(_this2), "handleIdentityTypeChange", function (val) {
      _this2.setState({
        form: _objectSpread(_objectSpread({}, _this2.state.form), {}, {
          identityType: val.status
        })
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "setupCommissionsAccount", function () {
      _this2.setState({
        submitting: true,
        submissionError: false
      });

      var payload = _objectSpread({}, _this2.state.form);

      _this2.props.createStripeBankToken(payload.selectedCountry.id, _this2.props.countrySpec.default_currency, payload.routingNumber, payload.accountNumber, "".concat(payload.firstName, " ").concat(payload.lastName), payload.identityType === 'IND' ? 'individual' : 'company', _this2.props.config.stripePublicKey).then(function (bank) {
        var data = {
          country: payload.selectedCountry.id,
          businessName: payload.businessName,
          firstName: payload.firstName,
          lastName: payload.lastName,
          currency: _this2.props.countrySpec.default_currency,
          accountId: bank.id,
          city: payload.city,
          address1: payload.address1,
          address2: payload.address2,
          postcode: payload.postcode,
          state: payload.state.id,
          dobDay: payload.verificationFields['legal_entity.dob.day'],
          dobMonth: payload.verificationFields['legal_entity.dob.month'],
          dobYear: payload.verificationFields['legal_entity.dob.year'],
          ssnLast4: payload.last4ssn,
          entityType: payload.identityType !== 'IND' ? 'company' : 'individual'
        };
        return _this2.props.createCommissionAccount(data);
      })["catch"](function (err) {
        var error = 'Something went wrong. Please try again later.';

        try {
          error = JSON.parse(err.message).message;
        } catch (e) {
          if (err && err.error && err.error.message) {
            error = "".concat(err.error.message);
          }
        }

        console.error(err);

        _this2.setState({
          submitting: false,
          submissionError: error
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this2), "validateRoutingNumber", function (routingNumber, accountNumber) {
      return Stripe.bankAccount.validateRoutingNumber(routingNumber, _this2.state.form.selectedCountry.id) || Stripe.bankAccount.validateAccountNumber(accountNumber, _this2.state.form.selectedCountry.id);
    });

    _defineProperty(_assertThisInitialized(_this2), "canSubmitSetup", function () {
      var form = _objectSpread({}, _this2.state.form);

      if (!form.firstName || !form.lastName || !form.routingNumber || !form.accountNumber || !form.confirm_accountNumber) {
        return false;
      }

      if (form.accountNumber !== form.confirm_accountNumber) {
        return false;
      }

      if (!_this2.validateRoutingNumber(form.routingNumber, form.accountNumber)) {
        return false;
      }

      var fields = _this2.props.verificationFields[form.identityType === 'IND' ? 'individual' : 'company'].minimum;

      if (fields.indexOf('legal_entity.dob.month') !== -1) {
        if (!form.verificationFields['legal_entity.dob.month'] || !form.verificationFields['legal_entity.dob.day'] || !form.verificationFields['legal_entity.dob.year']) {
          return false;
        }
      }

      if (fields.indexOf('legal_entity.ssn_last_4') !== -1) {
        if (!form.last4ssn || form.last4ssn.length !== 4) {
          return false;
        }
      }

      if (fields.indexOf('legal_entity.business_name') !== -1 && form.identityType !== 'IND') {
        if (!form.businessName || !form.businessTaxId) {
          return false;
        }
      }

      if (fields.indexOf('legal_entity.address.city') !== -1) {
        if (!form.state || !form.state.id || !form.city || !form.address1 || !form.postcode) {
          return false;
        }
      }

      return true;
    });

    _defineProperty(_assertThisInitialized(_this2), "localizedFieldName", function (fieldName) {
      var country = _this2.state.form.selectedCountry.id;

      switch (fieldName) {
        case 'account':
          return 'Account number';

        case 'account_confirm':
          return 'Confirm account number';

        case 'routing':
          return 'Routing number';

        case 'address_state':
          if (country === 'CA') {
            return 'Province';
          }

          return 'State';

        default:
          return '';
      }
    });

    var stripeConnectSupportedCountries = [{
      title: 'Canada',
      id: 'CA'
    }, {
      title: 'United States',
      id: 'US',
      "default": true
    }];
    _this2.state = {
      stripeConnectSupportedCountries: stripeConnectSupportedCountries,
      form: {
        selectedCountry: stripeConnectSupportedCountries.find(function (o) {
          return o["default"];
        }),
        identityType: 'IND',
        routingNumber: '',
        accountNumber: '',
        confirm_accountNumber: '',
        verificationFields: {
          'legal_entity.dob.month': 1,
          'legal_entity.dob.day': 1,
          'legal_entity.dob.year': moment().year() - 18
        }
      },
      submitting: false,
      submissionError: false,
      accountNumberErrorText: '',
      confirmAccountNumberDirty: false,
      routingNumberErrorText: ''
    };
    return _this2;
  }

  _createClass(BillingCommissions, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this = this;

      function afterLoadCommissionsAcct() {
        if (!_this.props.commissionsAccount || _this.props.commissionsAccount && _this.props.commissionsAccount.connectAccount && _this.props.commissionsAccount.connectAccount.bank_accounts && (!_this.props.commissionsAccount.connectAccount.bank_accounts.data || _this.props.commissionsAccount.connectAccount.bank_accounts.data.length === 0)) {
          console.log('Get verification fields...');

          _this.fetchRequiredVerificationFields(_this.state.form.selectedCountry.id);
        } else {
          _this.props.listAccountTransfers();

          _this.props.getCommissionsAccountBalance();
        }
      }

      this.props.loadCommissionsAccount().then(function (data) {
        afterLoadCommissionsAcct();
      })["catch"](function () {
        afterLoadCommissionsAcct();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var sidebarItems = [{
        link: '/user/billing',
        linkText: 'Billing'
      }, {
        link: '/user/commissions',
        linkText: 'Commissions'
      }];
      var hasSetupCommissions = this.props.commissionsAccount && this.props.commissionsAccount.connectAccount && this.props.commissionsAccount.connectAccount.bank_accounts && this.props.commissionsAccount.connectAccount.bank_accounts.data && this.props.commissionsAccount.connectAccount.bank_accounts.data.length > 0;
      var buttonBarItems = [{
        title: 'Individual',
        selected: this.state.form.identityType === 'IND',
        status: 'IND'
      }, {
        title: 'Company',
        selected: this.state.form.identityType === 'COM',
        status: 'COM'
      }];
      var appLayoutInnerStyle = {
        display: 'flex',
        flex: '1 1 auto',
        padding: 0,
        overflowX: 'auto',
        overflowY: 'auto',
        height: '100%'
      };
      return this.props.loadingCommissionAccount ? /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "billing",
        sidebarItems: sidebarItems,
        appLayoutInnerStyle: appLayoutInnerStyle,
        wrapStyle: {
          flex: '1 1 auto',
          paddingBottom: '36px'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Commissions"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingBottom: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Commissions"
      }))), /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          height: 75
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))) : /*#__PURE__*/React.createElement(LeftNavLayout, {
        sidebar: "billing",
        sidebarItems: sidebarItems,
        appLayoutInnerStyle: appLayoutInnerStyle,
        wrapStyle: {
          flex: '1 1 auto',
          paddingBottom: '36px'
        }
      }, /*#__PURE__*/React.createElement(Helmet, {
        title: "Commissions"
      }), /*#__PURE__*/React.createElement("div", {
        className: "container-fluid"
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          padding: 36,
          paddingBottom: 0
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(PageHeader, {
        primary: "Commissions"
      }))), !hasSetupCommissions && /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          maxWidth: 700,
          padding: '0 36px'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("p", {
        style: {
          marginTop: 0
        }
      }, "Likeable Local will automatically deposit a portion of the money your customers spend on Facebook advertisements into your bank account every Wednesday."), /*#__PURE__*/React.createElement("p", null, "To do this, we need a bank account as well as some personal information to verify your identity."))), !hasSetupCommissions && /*#__PURE__*/React.createElement("div", {
        className: "container",
        style: {
          maxWidth: 700,
          padding: '0 36'
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("span", {
        style: {
          lineHeight: '57px',
          verticalAlign: 'top'
        }
      }, "Country:"), /*#__PURE__*/React.createElement(LLDropDownList, {
        items: this.state.stripeConnectSupportedCountries,
        value: this.state.form.selectedCountry,
        onChange: this.handleCountryChange
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.modalHeader
      }, "Deposit Bank Account")), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        placeholder: this.localizedFieldName('routing'),
        fullWidth: true,
        errorText: this.state.routingNumberErrorText,
        value: this.state.form.routingNumber,
        onChange: function onChange(e, val) {
          return _this3.setState({
            form: _objectSpread(_objectSpread({}, _this3.state.form), {}, {
              routingNumber: val
            })
          });
        },
        onBlur: function onBlur() {
          var errorText = _this3.validateRoutingNumber(_this3.state.form.routingNumber, _this3.state.accountNumber) ? '' : "".concat(_this3.localizedFieldName('routing'), " is invalid");

          _this3.setState({
            routingNumberErrorText: errorText
          });
        }
      })), this.state.form.selectedCountry.id === 'CA' && /*#__PURE__*/React.createElement("small", {
        style: {
          marginLeft: 10
        }
      }, "We require both the 5 digit transit number (x) and the 3 digit financial institution number (y) in this format ", /*#__PURE__*/React.createElement("code", null, "xxxxx-yyy"), "."), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        placeholder: this.localizedFieldName('account'),
        type: "password",
        fullWidth: true,
        errorText: this.state.accountNumberErrorText,
        value: this.state.form.accountNumber,
        onChange: function onChange(e, val) {
          return _this3.setState({
            form: _objectSpread(_objectSpread({}, _this3.state.form), {}, {
              accountNumber: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(LLTextField, {
        placeholder: this.localizedFieldName('account_confirm'),
        type: "password",
        fullWidth: true,
        errorText: this.state.accountNumberErrorText,
        value: this.state.form.confirm_accountNumber,
        onBlur: function onBlur(e) {
          var errorText = '';

          if (_this3.state.form.accountNumber !== _this3.state.form.confirm_accountNumber) {
            errorText = 'The account numbers do not match';
          }

          _this3.setState({
            confirmAccountNumberDirty: true,
            accountNumberErrorText: errorText
          });
        },
        onChange: function onChange(e, val) {
          var errorText = '';

          if (_this3.state.form.accountNumber !== val && _this3.state.confirmAccountNumberDirty) {
            errorText = 'The account numbers do not match';
          }

          _this3.setState({
            accountNumberErrorText: errorText,
            form: _objectSpread(_objectSpread({}, _this3.state.form), {}, {
              confirm_accountNumber: val
            })
          });
        }
      })), /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement("h3", {
        className: styles.modalHeader
      }, "Identity Verification")), /*#__PURE__*/React.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, /*#__PURE__*/React.createElement(ButtonBar, {
        items: buttonBarItems,
        onChange: this.handleIdentityTypeChange
      }))), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          minHeight: 80,
          width: '100%'
        }
      }, this.props.fetchingFields ? /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12",
        style: {
          position: 'relative'
        }
      }, /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })) : /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12"
      }, this.renderIdentityForm()))), this.state.submissionError && /*#__PURE__*/React.createElement("p", {
        style: {
          color: 'red'
        }
      }, this.state.submissionError), /*#__PURE__*/React.createElement("div", {
        className: "row",
        style: {
          marginTop: 20,
          marginBottom: 36
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-xs-12 col-sm-6",
        style: {
          minHeight: 55,
          position: 'relative'
        }
      }, !this.state.submitting ? /*#__PURE__*/React.createElement(SecondaryButton, {
        label: "Setup Commissions",
        disabled: !this.canSubmitSetup(),
        onClick: this.setupCommissionsAccount
      }) : /*#__PURE__*/React.createElement(Spinner, {
        center: true
      })))), hasSetupCommissions && /*#__PURE__*/React.createElement(CommissionsView, null)));
    }
  }]);

  return BillingCommissions;
}(Component)) || _class);
export { BillingCommissions as default };